import React from 'react';
import classNames from 'classnames';
import { ModalBodyProps } from '../types';
import { useModalContext } from '../ModalContext';

import styles from './index.module.scss';

const ModalBody = ({ children, topPadding = false }: ModalBodyProps) => {
  const { centered } = useModalContext();

  return (
    <div
      className={classNames(
        {
          [styles.itemsCentered]: centered,
          [styles.topPadding]: topPadding,
        },
        styles.container
      )}
    >
      {children}
    </div>
  );
};

ModalBody.displayName = 'ModalBody';

export default ModalBody;
